import React, { useState, useRef, useEffect, useCallback } from "react";
import { setIsWidth } from '../../store/slice/currentStageSlice';
import { currentStageData } from '../../store/slice/currentStageSlice';
import { useDispatch, useSelector } from "react-redux";
import GisApiServices from "../../services/GisApiServices";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
const Activities = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 });
  const switchDivRef = useRef(null);
  const navigate = useNavigate();
  const { isTheme } = useSelector((state) => state.currentStage)
  const dispatch = useDispatch()
  const authData = useSelector(state => state.authToken.authData);
  const [isGetPermission, setIsGetPermission] = useState([]);


  const tabs = [
    // {
    //   id: "tab1",
    //   label: "Recent Activities",
    //   content: <RecentActivities />,
    //   activeImage: isTheme === 'light' ? "img/recent-light.svg" : "img/recentdeactive.svg",
    //   inactiveImage: isTheme === 'light' ? "img/recent-de-light.svg" : "img/recentdeactive.svg",
    //   activityCount: 3,
    //   activityId: 'A1'
    // },
    {
      id: "tab2",
      label: "Notifications",
      content: <Notification />,
      activeImage: isTheme === 'light' ? "img/notification-light.svg" : "img/notificationdeactive.svg",
      inactiveImage: isTheme === 'light' ? "img/notification-deactive-light.svg" : "img/notificationdeactive.svg",
      // activityCount: 3,
      activityId: 'A2'
    },
    {
      id: "tab3",
      label: "User Activity",
      content: <UserActivity />,
      activeImage: isTheme === 'light' ? "img/user-light.svg" : "img/useractivitydeactive.svg",
      inactiveImage: isTheme === 'light' ? "img/userdeactivelight.svg" : "img/useractivitydeactive.svg",
      // activityCount: 3,
      activityId: 'A3'
    },
  ];

  const fetchUserPermission = async () => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }
      const value = {
        role_Id: authData?.RoleID
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };
      const response = await GisApiServices.userPermissions(value, config);
      const getPermission = response.data?.data || [];
      setIsGetPermission(getPermission?.permissions)
    } catch (error) {
      console.error("Error fetching user roles", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchUserPermission()
  }, [])

  useEffect(() => {
    dispatch(setIsWidth(false))
    dispatch(currentStageData(''))
    const updateSlider = () => {
      const activeElement = switchDivRef.current.querySelector(".active-tab-act");
      if (activeElement) {
        const { offsetLeft: left, offsetWidth: width } = activeElement;
        setSliderStyle({ left, width });
      }
    };

    updateSlider();
    window.addEventListener("resize", updateSlider);

    return () => {
      window.removeEventListener("resize", updateSlider);
    };
  }, [activeTab]);

  const filteredTabs = tabs.filter(tab =>
    isGetPermission.some(permission => permission.activityId === tab.activityId)
  );


  return (
    <div>
      {/* <div className="filterdiv">
        <div className="row gx-0">
          <div className="col-lg-6 col-md-12">
            <div className="fildiv" style={{ gap: "12px" }}>
              <div className="search-container1">
                <input
                  className="access-search"
                  placeholder="Search activity"
                />
                <span className="search-img">
                  {isTheme === "light" ? <img src="img/bluesearch.svg" alt='search' /> :
                    <img src="img/Vectorsearch.png" alt='search' />}
                </span>
              </div>
              <button className="filter-btn">Filter</button>
              <button className="filter-btn">Sort</button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="switch-tabs">
        {/* Tab Buttons */}
        <div className="switchdivact" ref={switchDivRef}>
          {filteredTabs.map((tab) => (
            <div
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn-access-switch ${activeTab === tab.id ? "active-tab-act" : ""}`}
            >
              <img
                src={activeTab === tab.id ? tab.activeImage : tab.inactiveImage}
                alt={tab.label}
                className="tab-icon"
              />
              <span>{tab.label}</span>
              {/* <span className="activity-count">{tab.activityCount}</span> */}
            </div>
          ))}
          <div
            className="acitveslider"
            style={{ ...sliderStyle, transition: "all 0.3s ease" }}
          ></div>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {filteredTabs.map(
            (tab) =>
              activeTab === tab.id && (
                <div key={tab.id} className="tab-panel">
                  {tab.content}
                </div>
              )
          )}
        </div>
      </div>

    </div>
  );
};

const RecentActivities = () => {
  return (
    <div>
      <div className="table-responsive mt-3">
        <table className="table table-dark-security caption-top manage-user-table">
          <thead>
            <tr>
              <th scope="col" className="text-start">User name</th>
              <th scope="col">Action type</th>
              <th scope="col">Dataset or module</th>
              <th scope="col">Date</th>
              <th scope="col">Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-start">user_mpgov_1311
                <br />
                admin.mp@mpgov.com
              </td>
              <td>Data Upload</td>
              <td>Water bodies</td>
              <td>13 Nov 2024,7:18</td>
              <td>13hh:36mm:44ss</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  )
}

const Notification = () => {
  const { isTheme } = useSelector((state) => state.currentStage)
  return (
    <div className="mt-2">
      {/* <h6 className="notifucationtitle">Today, 13 Nov 2024</h6> */}
      <div className="row px-3">
        <div className="col-md-9">
          <div className="row notificationinfodiv align-items-center">
            <div className="col-md-10 col-9 p-0">
              <div className="inside">
                {isTheme === 'light' ? <img src="img/folderlight.svg" alt="folder" /> :
                  <img src="img/folderImg" alt="folder" />}
                <div>
                  <h5 className="notificationhead m-0">New Data Added</h5>
                  <h6 className="notificationtext m-0">New dataset 'City Infrastructure' uploaded by Virendra Shah</h6>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-3 p-0 text-end">
              <h6 className="notificationtext m-0">02:00 PM</h6>
            </div>
          </div>

          <div className="row notificationinfodiv mt-2 align-items-center">
            <div className="col-md-10 col-9 p-0">
              <div className="inside">
                <img src="img/checkeddata.svg" alt="folder" />
                <div>
                  <h5 className="notificationhead m-0">Data Analysis Completed</h5>
                  <h6 className="notificationtext m-0">Analysis on 'Railway Track Lines' completed by Virendra Shah</h6>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-3 p-0 text-end">
              <h6 className="notificationtext m-0">02:00 PM</h6>
            </div>
          </div>

          <div className="row notificationinfodiv mt-2 align-items-center">
            <div className="col-md-10 col-9 p-0">
              <div className="inside">
                <img src="img/trash-bin2.svg" alt="folder" />
                <div>
                  <h5 className="notificationhead m-0">Data Analysis Completed</h5>
                  <h6 className="notificationtext m-0">Analysis on 'Railway Track Lines' completed by Virendra Shah</h6>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-3 p-0 text-end">
              <h6 className="notificationtext m-0">02:00 PM</h6>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}



// const UserActivity = () => {
//   const [security, setSecurity] = useState("loginhistory");
//   const [loginHistory, setLoginHistory] = useState([]);
//   const [moduleHistory, setModuleHistory] = useState([]);

//   const handleSecurity = useCallback((data) => {
//     setSecurity(data);
//     fetchModule(data);
//   }, []);

//   useEffect(() => {
//     fetchModule(security);
//   }, [])

//   const fetchModule = async (dataType) => {
//     try {
//       const value = {
//         pageNumber: 1,
//         pageSize: 10,
//         requesttype: dataType === "loginhistory" ? "login" : "module"
//       };

//       const response = await GisApiServices.moduleAccess(value);
//       const data = response.data?.data || [];

//       if (dataType === "loginhistory") {
//         setLoginHistory(data);
//       } else {
//         setModuleHistory(data);
//       }

//     } catch (error) {
//       console.error("Error fetching departments", error);
//     }
//   };

//   const formatTime = (dateString) => {
//     const date = new Date(dateString);

//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//     const year = date.getFullYear();

//     const time = date.toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     });

//     return `${day}-${month}-${year} ${time}`;
//   };


//   const tabs = [
//     { key: "loginhistory", label: "Login History" },
//     { key: "accessmodule", label: "Module Access" },
//   ];

//   const content = {
//     loginhistory: (
//       <div>
//         <div className="table-responsive">
//           <table className="table table-dark-security caption-top manage-user-table">
//             <thead>
//               <tr>
//                 <th scope="col" className="text-start">User ID</th>
//                 <th scope="col">Log Module</th>
//                 <th scope="col">Log Activity</th>
//                 <th scope="col">Log Type</th>
//                 <th scope="col">Log date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loginHistory.map((item, index) => (
//                 <tr key={item.id || index}>
//                   <td className="text-start">
//                     {item.userId}
//                   </td>
//                   <td>{item.logModule}</td>
//                   <td>{item.logActivity}</td>
//                   <td>{item.logType}</td>
//                   <td>{formatTime(item.logdate)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     ),
//     accessmodule: (
//       <div>
//         {/* <h6 className="notifucationtitle">Today, 13 Nov 2024</h6> */}
//         <div className="table-responsive">
//           <table className="table table-dark-security caption-top manage-user-table">
//             <thead>
//               <tr>
//                 <th scope="col" className="text-start">User ID</th>
//                 <th scope="col">Log Module</th>
//                 <th scope="col">Log Activity</th>
//                 <th scope="col">Log Type</th>
//                 <th scope="col">Log date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {moduleHistory.map((item, index) => (
//                 <tr key={item.id || index}>
//                   <td className="text-start">
//                     {item.userId}
//                   </td>
//                   <td>{item.logModule}</td>
//                   <td>{item.logActivity}</td>
//                   <td>{item.logType}</td>
//                   <td>{formatTime(item.logdate)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     ),
//   };

//   return (
//     <>
//       <div>
//         <div style={{ width: "16.3rem" }} className="mb-5">
//           <div className="managetabs mt-3">
//             {tabs.map((tab) => (
//               <button
//                 key={tab.key}
//                 onClick={() => handleSecurity(tab.key)}
//                 aria-selected={security === tab.key}
//                 className={`role-text  ${security === tab.key ? "role-active" : "role-inactive activitybtn"}`}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="col-lg-9 col-md-12">
//         {content[security]}
//       </div>
//     </>

//   );
// };

const UserActivity = () => {
  const [security, setSecurity] = useState("loginhistory");
  
  const [loginHistory, setLoginHistory] = useState([]);
  const [moduleHistory, setModuleHistory] = useState([]);
  const [searchText, setSearchText] = useState("");
  const { isTheme } = useSelector((state) => state.currentStage);
  const navigate = useNavigate();
  const authData = useSelector(state => state.authToken.authData);
  console.log("authData121",authData)
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalRows: 0,
  });

  const handleSecurity = useCallback((data) => {
    setSecurity(data);
    setSearchText("");
    setPagination((prev) => ({ ...prev, page: 1 }));
  }, []);

  useEffect(() => {
    if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
      fetchModuleUser(security, pagination.page, pagination.pageSize);
    } else {
      fetchModule(security, pagination.page, pagination.pageSize);
    }

  }, [security, pagination.page, pagination.pageSize]);

  const fetchModule = async (dataType, pageNumber = 1, pageSize = 10) => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };
      const value = {
        pageNumber,
        pageSize,
        requesttype: dataType === "loginhistory" ? "login" : "module",
      };

      const response = await GisApiServices.moduleAccess(value, config);
      const data = response.data?.data || [];
      const totalCount = response.data?.totalCount || data.length;

      if (dataType === "loginhistory") {
        setLoginHistory(data);
      } else {
        setModuleHistory(data);
      }

      setPagination((prev) => ({
        ...prev,
        totalRows: totalCount,
      }));
    } catch (error) {
      console.error("Error fetching module data", error);
    }
  };

  const fetchModuleUser = async (dataType, pageNumber = 1, pageSize = 10) => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };
      const value = {
        pageNumber,
        pageSize,
        requesttype: dataType === "loginhistory" ? "LOGIN" : "MODULE",
        //  requesttype: "LOGIN",
         userId: authData?.UserID
      };

      const response = await GisApiServices.GetLogsByUser(value, config);
      const data = response.data?.data || [];
      const totalCount = response.data?.totalCount || data.length;

      if (dataType === "loginhistory") {
        setLoginHistory(data);
      } else {
        setModuleHistory(data);
      }

      setPagination((prev) => ({
        ...prev,
        totalRows: totalCount,
      }));
    } catch (error) {
      console.error("Error fetching module data", error);
    }
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${day}-${month}-${year} ${time}`;
  };

  const columns = [
    { name: "User ID", selector: (row) => row.userId, sortable: true },
    { name: "Log Module", selector: (row) => row.logModule, sortable: true },
    { name: "Log Activity", selector: (row) => row.logActivity, sortable: true },
    { name: "Log Type", selector: (row) => row.logType, sortable: true },
    { name: "Log Date", selector: (row) => formatTime(row.logdate), sortable: true },
  ];

  const customStyles = {
    headRow: { style: { background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)", color: "white" } },
    rows: { style: { backgroundColor: "white", color: "black" } },
    headCells: { style: { color: "white", fontWeight: "bold" } },
  };

  const filterData = (data) =>
    data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: newPageSize,
      page: 1,
    }));
  };

  const tabs = [
    { key: "loginhistory", label: "Login History" },
    { key: "accessmodule", label: "Module Access" },
  ];

  const renderTable = (data, noDataMessage) => (
    <>
      <div className="row">
        <div className="col-md-4">
          <div className="search-container1">
            <input
              type="text"
              placeholder="Search activity"
              className="access-search mb-3"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span className="search-img">
              {isTheme === "light" ? (
                <img src="img/bluesearch.svg" alt="search" />
              ) : (
                <img src="img/Vectorsearch.png" alt="search" />
              )}
            </span>
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={searchText ? filterData(data) : data}
        pagination
        paginationServer={!searchText}
        paginationTotalRows={pagination.totalRows}
        paginationPerPage={pagination.pageSize}
        paginationCurrentPage={pagination.page}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        responsive
        customStyles={customStyles}
        noDataComponent={noDataMessage}
        persistTableHead
      />
    </>
  );

  return (
    <div>
      <div style={{ width: "16.3rem" }} className="mb-3">
        <div className="managetabs mt-3">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleSecurity(tab.key)}
              aria-selected={security === tab.key}
              className={`role-text ${security === tab.key ? "role-active" : "role-inactive activitybtn"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="col-lg-9 col-md-12">
        {security === "loginhistory"
          ? renderTable(loginHistory, "No login history found")
          : renderTable(moduleHistory, "No module access found")}
      </div>
    </div>
  );
};





export default Activities;



